import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

import { DirectoryItemModel } from "../../models/directory-item.model";
import { PostcodesGeolocationService } from "../../../../../shared-library/services/geolocation/postcodes-geolocation.service";
import { MapMarkerModel } from "./map-marker.model";

@Injectable({
    providedIn: "root"
})
export class GoogleMapService {
    private markersInternal$ = new BehaviorSubject<Array<MapMarkerModel>>([]);
    private mapVisibilityInternal$ = new BehaviorSubject({showMap: false});
    public markers$ = this.markersInternal$.asObservable();
    public mapVisibility$ = this.mapVisibilityInternal$.asObservable();

    public constructor(private postcodesGeolocationService: PostcodesGeolocationService) {
    }

    public addMarker(model: DirectoryItemModel, viewPageUrl: string): void {
        if (!!model.latitude && !!model.longitude) {
            const position = new google.maps.LatLng(model.latitude, model.longitude);
            this.addMarkerToMap(model, viewPageUrl, position);
        } else if (!!model.postcode) {
            this.postcodesGeolocationService.getCoordinatesByPostcode(model.postcode).subscribe({
                next: (result) => {
                    if (result?.result?.latitude && result?.result?.longitude) {
                        const { latitude, longitude } = result.result;
                        const position = new google.maps.LatLng(latitude, longitude);
                        this.addMarkerToMap(model, viewPageUrl, position);
                    } else {
                        console.error("Coordinates not found for postcode:", model.postcode);
                    }
                },
                error: (err) => {
                    console.error("Error fetching coordinates:", err);
                }
            });
        }
    }

    public clear(): void{
        this.markersInternal$.next([]);
    }

    public showMap(): void {
        this.mapVisibilityInternal$.next({showMap: true});

        this.updateAriaLabel();
    }

    public hideMap(): void {
        this.mapVisibilityInternal$.next({showMap: false});
    }

    private updateAriaLabel(): void {
        setTimeout(() => {
            $("div[aria-label='Map']").attr("aria-label", "Google Map of Hampshire");
        }, 100);
    }

    private addMarkerToMap(model: DirectoryItemModel, viewPageUrl: string, position: google.maps.LatLng): void {
        const url = `${viewPageUrl}?id=${model.id}`;

        const infoWindowContent = "<div class='pcg-google-map-info-window'>"
            + `<a href='${url}' class='pcg-google-map-info-window__title'>${model.name}</a>`
            + (model.fullPostalAddress ? `<br/><span>${model.fullPostalAddress}</span>` : "")
            + (model.phone ? `<br/><span><b>Phone:</b> ${model.phone}</span>` : "")
            + (model.email ? `<br/><span><b>Email:</b> ${model.email}</span>` : "")
            + (model.website ? `<br/><span><a href="${model.website}" target="_blank">${model.shortWebsiteAddress}</a></span>` : "")
            + "</div>";

        this.markersInternal$.next([...this.markersInternal$.value, {
            position: position,
            label: null,
            title: model.name,
            info: infoWindowContent,
            options: {
                animation: google.maps.Animation.DROP,
                draggable: false
            }
        }]);
    }
}
